/* tslint:disable */
export interface ICallHeader {
  Name: string;
  Value?: string | object | ICallSettings | any;
}

export class XApiKeyHeader implements ICallHeader {
  Name = 'X-API-Key';
  Value = '';
}

export interface ICallSettings {
  Company: string;
  Plant?: string;
  Language?: string;
  FormatCulture?: string;
  TimezoneOffset?: number;
}

export class CallSettingsHeader implements ICallHeader {
  Name = 'CallSettings';
  Value: ICallSettings = {
    Company: ''
  };
}

export interface ILicenseHeader {
  ClaimedLicense: string;
  SessionID?: string;
}

export class LicenseHeader implements ICallHeader {
  Name = 'License';
  Value: ILicenseHeader = {
    ClaimedLicense: ''
  };
}

export class SessionInfoHeader implements ICallHeader {
  Name = 'SessionInfo';
  Value = {
    SessionID: ''
  };
}

export class CallInfoHeader implements ICallHeader {
  Name = 'CallInfo';
  Value = {
    CorrelationID: ''
  };
}

export enum AuthorizationHeaderProcessing {
  SkipHeader = 'skip',
  UseBasicAuth = 'basic',
  UseHeaderValue = 'headerValue'
}

export interface IAuthorizationHeaderSettings {
  ProcessingType?: AuthorizationHeaderProcessing;
  UserName?: string;
  Password?: string;
  Value?: string;
}

export class AuthorizationHeader implements ICallHeader {
  Name = 'Authorization';
  Value: IAuthorizationHeaderSettings = {};
}

export class CustomHeader implements ICallHeader {
  Name = '';
  Value = '';
}
/* tslint:enable */

export enum HeaderTypes {
  ApiKey = 'API Key',
  CallSettings = 'Call Settings',
  SessionInfo = 'Session Info',
  License = 'License',
  CallInfo = 'Call Info',
  Authorization = 'Authorization' // skip or Basic Auth or string...
}
